
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import PartnerModal from './PartnerModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';

const PartnerList = ({ }) => {
    const [partners, setPartner] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedPartnerId, setSelectedPartnerId] = useState(null);
    const [selectedPartnerData, setSelectedPartnerData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [organisations, setOrganisation] = useState([]);
    const [errors, setErrors] = useState({});
    const [contacts, setContacts] = useState([]);
    const WithCreatePermission = withPermission(({ children }) => children, ['partner-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['partner-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['partner-delete']);
    const didFetchRef = useRef(false);
   const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);

    const didInitialFetch = useRef(false);
   
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchPartner(1, searchQuery);
        }, searchQuery ? 1500 : 0); 

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };    
    const fetchPartner = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/partners`, {
                headers: { Authorization: `Bearer ${token}` },
                params: {
                    page,
                    search: searchQuery,
                },
            });

            const { data, current_page, last_page } = response.data.data;

            setPartner(data);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);
        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };

    
    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: { Authorization: `Bearer ${token}` },
                
            });

            const  data = response.data.data;

            setOrganisation(data);
            
        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };
    const addPartner = async (newPartner) => {
        try {
           

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/partners`, newPartner, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const createdPartner = response.data.data;

            if (createdPartner) {
                setPartner((prevPartner) => [...prevPartner, createdPartner]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };


    const editPartner = async (contactId, updatedData) => {
        try {
            
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/partners/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const updatedPartner = response.data.Data;

            if (updatedPartner) {
                setPartner((prevPartner) =>
                    prevPartner.map((contact) => (contact.id === updatedPartner.id ? updatedPartner : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };

    const deletePartner = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for deleting
            await axios.delete(`${backendUrl}/api/partners/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setPartner(partners.filter((contact) => contact.id !== id));
            Swal.fire(
                "Deleted!",
                "The partner has been deleted.",
                "success"
            );
        } catch (error) {
            console.error('Error deleting partner:', error);
            Swal.fire(
                "Error!",
                "Failed to delete partner. Please try again.",
                "error"
            );
        }
    }
});
    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = partners.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedPartnerData(contactToEdit);
            }
        } else {
            setSelectedPartnerData(null);
        }
        setSelectedPartnerId(contactId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPartnerId(null);
        setSelectedPartnerData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchPartner(selectedPage);
    };
   
    
    

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    Partners
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                       
                                        <WithCreatePermission>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-rounded waves-effect waves-light mb-3"
                                            onClick={() => handleShowModal()}
                                        >
                                            <i className="mdi mdi-plus me-1"></i> Add Partner
                                        </button></WithCreatePermission>
                                    </div>

                                    <table className="table align-middle table-nowrap table-check">
                                        <thead className="table-sales-gradient">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle"> Name</th>
                                                <th className="align-middle">Organisation</th>
                                                <th className="align-middle">Stage</th>
                                                <th className="align-middle">Value</th>

                                                <th className="align-middle">Closed Date</th>

                                                <th className="align-middle">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {partners.length > 0 ? (
                                                partners.map((partner, index) => (
                                                    <tr key={partner.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`partnerCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`partnerCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>

                                                        <td>
                                                            <Link to={`/partner/details/${partner.id}`} className="dropdown-item">
                                                            {partner.name}
                                                            </Link>
                                                        </td>

                                                        <td> {partner.organisation ? partner.organisation.name : " "}</td>
                                                        <td>{partner.stage}</td>
                                                        <td>{partner.value}</td>

                                                        <td>{partner.closed_date}</td>

                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end">
                                                                    <li>
                                                                        <Link to={`/partner/details/${partner.id}`} className="dropdown-item">
                                                                            View Details
                                                                        </Link>
                                                                    </li>
                                                                    <li><WithEditPermission>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleShowModal(partner.id)}
                                                                        >
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => deletePartner(partner.id)}
                                                                        >
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No partners found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={"<<"}
                                            nextLabel={">>"}
                                            breakLabel={"..."}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination justify-content-center pagination-sm'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PartnerModal
                showModal={showModal}
                handleClose={handleCloseModal}
                partnerId={selectedPartnerId}
                partnerData={selectedPartnerData}
                addPartner={addPartner}
                editPartner={editPartner}
                partners={partners}
                fetchOrganisation={fetchOrganisation}   
                errors={errors}
                setErrors={setErrors}
                organisations={organisations}
            />
        </div>
    );
};

export default PartnerList;




